/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ReactNode, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import Button from 'components/button/Button';
import PinCodeField from 'components/forms/pinCodeField/PinCodeField';
import FormFieldset from '../../../forms/form/FormFieldset';
import {
  HelperTextMuted,
  ResendCode,
  TypeStartingEnding,
} from './MFACodeForm.styles';
import { MFAType } from './MFA.types';

interface Props {
  errorMessage?: string | ReactNode;
  clearErrors?: () => void;
  codeSentTo: string;
  isSubmitting?: boolean;
  resendCode: () => void;
  type?: MFAType;
}

const MFACodeForm = ({
  errorMessage,
  clearErrors,
  codeSentTo,
  isSubmitting,
  resendCode,
  type,
}: Props) => {
  const { pinCode } = useWatch();
  const { t } = useTranslation();

  useEffect(() => {
    // @ts-expect-error TS2722 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    clearErrors();
  }, [pinCode]);

  return (
    <FormFieldset disabled={isSubmitting}>
      <HelperTextMuted>{t('pageLogin.pleaseEnterCode')}</HelperTextMuted>
      <TypeStartingEnding>
        {type === MFAType.EMAIL
          ? t('pageLogin.emailStartingWith')
          : t('pageLogin.phoneEndingIn')}{' '}
        {codeSentTo}
      </TypeStartingEnding>
      <PinCodeField name="pinCode" length={6} submitWhenPasted />
      <Button
        data-testid="submit-button"
        disabled={!!errorMessage}
        type="submit"
        block
        bsSize="large"
      >
        {t('pageLogin.continue')}
      </Button>
      <ResendCode>
        <Trans
          i18nKey="pageLogin.resendCodeLink"
          components={{
            wrap: (<span onClick={() => resendCode()} />) as any,
          }}
        />
      </ResendCode>
      {!!errorMessage && (
        <p className="error-message" data-testid="error-message">
          {errorMessage}
        </p>
      )}
    </FormFieldset>
  );
};

MFACodeForm.defaultProps = {
  errorMessage: '',
  clearErrors: () => {},
  isSubmitting: false,
  type: undefined,
};

export default MFACodeForm;
